import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import type { IItemState } from '../../pages/episodes/Episode';
import { ProcessScrollItem } from '../../../../common/enums/processScrollItem';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { ReloadEpisode } from '../../pages/episodes/reloadEpisode';
import { Button } from '../common';

interface IResendReferralButtonProps {
    reloadProcess: (mode?: ReloadEpisode) => Promise<void>;
    request: IRequestGetOne;
    updateProcessItemStateByRequestId?: (
        requestId: string,
        itemState: IItemState,
        scrollItem: ProcessScrollItem
    ) => Promise<void>;
}

export function ResendReferralButton(props: IResendReferralButtonProps) {
    if (
        props.request.status !== RequestStatus.rejected ||
        !props.request.authorization ||
        !props.request.authorization.canUpdateRejectedRequestToResent
    ) {
        return null;
    }

    return (
        <Button
            automation="resendReferral"
            color="secondary"
            large
            onClick={async () => {
                const result = await fetchJson(`/api/requests/${props.request.id}/resendReferral`, 'POST');
                await props.reloadProcess(ReloadEpisode.reloadAll);
                if (props.updateProcessItemStateByRequestId) {
                    await props.updateProcessItemStateByRequestId(
                        result.json.id,
                        { isOpen: true, mode: 'edit' },
                        ProcessScrollItem.request
                    );
                }
            }}
        >
            {translateKey('request.statusAction_resendReferral')}
        </Button>
    );
}
